module.exports = __webpack_public_path__ + "media/images/advertise/light_green_advertise-3ddcd79ffe6a563a724b8f75e4e897e6.png";